import { render, staticRenderFns } from "./errHint.vue?vue&type=template&id=28827b8a&scoped=true"
import script from "./errHint.vue?vue&type=script&lang=js"
export * from "./errHint.vue?vue&type=script&lang=js"
import style0 from "./errHint.vue?vue&type=style&index=0&id=28827b8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28827b8a",
  null
  
)

export default component.exports